import React from 'react';
import Icon from '../../../components/AppIcon';

const StorageQuota = ({ used, total }) => {
  const formatBytes = (bytes) => {
    if (bytes === 0) return '0 GB';
    const gb = bytes / (1024 * 1024 * 1024);
    return gb?.toFixed(2) + ' GB';
  };

  const percentage = (used / total) * 100;
  const isWarning = percentage > 80;
  const isCritical = percentage > 90;

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Icon name="HardDrive" size={20} className="text-primary" />
          <h3 className="text-sm font-semibold text-foreground">Storage Quota</h3>
        </div>
        <span className="text-xs font-mono text-muted-foreground">
          {formatBytes(used)} / {formatBytes(total)}
        </span>
      </div>
      <div className="w-full bg-muted rounded-full h-2 mb-2">
        <div
          className={`h-2 rounded-full transition-all duration-300 ${
            isCritical
              ? 'bg-error'
              : isWarning
              ? 'bg-warning' :'bg-primary'
          }`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      <p className="text-xs text-muted-foreground">
        {percentage?.toFixed(1)}% used
        {isWarning && ' - Consider freeing up space'}
      </p>
    </div>
  );
};

export default StorageQuota;